import P from '../../pages';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { defaultMessages } from '../../../../libs/i18n/default';
import ReactOnRails from 'react-on-rails';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import Button from 'react-bootstrap/lib/Button';
import Modal from 'react-bootstrap/lib/Modal';
import { Redirect } from 'react-router-dom';
import CheckboxOrRadioGroup from './CheckboxOrRadioGroup';
import SelectGroup from './SelectGroup';
import ButtonGroup from './ButtonGroup';
import RoomForm from './RoomForm';
import ReactMarkdown from 'react-markdown';
import Home from 'react-icons/lib/md/home';
import Edit from 'react-icons/lib/md/edit';
import RoomPhotoUpload from './RoomPhotoUpload';
import TableRow from './TableRow';
import Alert from './Alert';
import ProfileElementField from './ProfileElementField';
import CustomFormGroup from './CustomFormGroup';
import { generateProfileElementObject, changeState } from '../../utilities';

class Rooms extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      rooms: this.props.rooms,
      numBedrooms: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'home', 'num_bedrooms'),
      numBathrooms: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'home', 'num_bathrooms'),
      numBedroomsForGuests: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements, '', 'home', 'num_bedrooms_for_guests')
    }
    this.handleEditRoom = this.handleEditRoom.bind(this);
    this.submit = this.submit.bind(this);
    this.back = this.back.bind(this);
    this.skip = this.skip.bind(this);
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.handleNewRoom = this.handleNewRoom.bind(this);
    this.pageValid = this.pageValid.bind(this);
    this.changeState = this.changeState.bind(this);
  }

  getInitialState() {
    return {
      showModal: false,
      editing: false
    };
  }

  handleNewRoom() {
    this.setState({
      showModal: true,
      editing: true,
      activeRoom: {
          name: '',
          bathroom_type: '',
          bed_type: '',
          notes: '',
          door_lock: false,
        }
    });
  }

  handleEditRoom(e, payload) {
    e.preventDefault()
    this.setState({
      showModal: true,
      editing: true,
      activeRoom: payload
    });
  }

  componentWillMount() {
    this.props.onFetchRoomsIfNeeded();
  }

  changeState = async(id, val) => {
    changeState(this, id, val)
  }

  componentWillReceiveProps(newProps){
    if (this.state.rooms != newProps.rooms){
      this.setState({rooms: newProps.rooms})
    }
  }

  pageValid(){
    let rooms = this.state.rooms.items
    return(
      rooms.length > 0 &&
      (this.props.territory.code != 'SRSC' || rooms.every(r => r.photos.length > 0))
    )
  }

  back(e) {
    this.props.onGoBack();
  }

  submit(e) {
    this.props.onRoomsSubmit();

    this.props.onHostProfileSubmit({
      home: {
        num_bedrooms: this.state.numBedrooms.val,
        num_bathrooms: this.state.numBathrooms.val,
        num_bedrooms_for_guests: this.state.numBedroomsForGuests.val,
      }
    });
  }

  skip(e) {
    e.preventDefault();
    this.props.onSkipSubmit();
  }

  close() {
    this.setState({ showModal: false });
    this.props.onFetchRoomsIfNeeded();
  }

  open() {
    this.setState({ showModal: true });
  }

  render() {
    const thisPage = P.ROOMS_PAGE;
    const { formatMessage } = this.props.intl;
    const content = this.props.content;
    const page = this.props.page;
    const { items: rooms, isFetching, lastUpdated } = this.props.rooms
    const {editing, activeRoom, formAction} = this.state

    return (
      <div id={page} className='profile'>
        <Redirector this_page={thisPage} page={page}/>
        <form>
          <FormHeader title={content.pages.rooms.title} icon={<Home />}/>
          <ProfileElementField
            childComponent={
              <SelectGroup
                title={formatMessage(defaultMessages.clientHostPagesRoomsLabelsNumBedrooms)}
                setId={'numBedrooms'}
                options={this.props.numBedrooms}
                defaultValue={this.state.numBedrooms.val}
                valid={this.state.numBedrooms.valid}
                controlFunc={e => this.changeState(e.target.id, e.target.value)}
              />
            }
            elementName='num_bedrooms'
          />
          <ProfileElementField
            childComponent={
              <SelectGroup
                title={formatMessage(defaultMessages.clientHostPagesRoomsLabelsNumBathrooms)}
                setId={'numBathrooms'}
                options={this.props.numBathrooms}
                defaultValue={this.state.numBathrooms.val}
                valid={this.state.numBathrooms.valid}
                controlFunc={e => this.changeState(e.target.id, e.target.value)}
              />
            }
            elementName='num_bathrooms'
          />
          <ProfileElementField
            childComponent={
              <SelectGroup
                title={formatMessage(defaultMessages.clientHostPagesRoomsLabelsNumBedroomsForGuests)}
                setId={'numBedroomsForGuests'}
                options={this.props.numBedroomsForGuests}
                defaultValue={this.state.numBedroomsForGuests.val}
                valid={this.state.numBedroomsForGuests.valid}
                controlFunc={e => this.changeState(e.target.id, e.target.value)}
              />
            }
            elementName='num_bedrooms_for_guests'
          />

          <Alert alert={content.pages.rooms.info} />

          <Button
            onClick={this.handleNewRoom}
            id='add-btn'>
            {formatMessage(defaultMessages.clientHostPagesRoomsActionsCreate)}
          </Button>

          <table className="table table-striped">
            <thead>
              <tr>
                <th>{formatMessage(defaultMessages.clientHostPagesRoomsTableName)}</th>
                <th>
                  {formatMessage(defaultMessages.clientHostPagesRoomsTableBedType)} / {formatMessage(defaultMessages.clientHostPagesRoomsTableBathroomType)}
                </th>
                <th>{formatMessage(defaultMessages.clientHostPagesRoomsTablePhotos)}</th>
                <th>Edit</th>
                {
                  this.props.territory.code == 'SRSC' &&
                  <th></th>
                }
              </tr>
            </thead>
            <tbody>
              {rooms.map((room, i) => {
                return (
                  <TableRow showValidation={this.props.territory.code == 'SRSC'} valid={room.photos.length > 0} key={room.id} rowKey={i}>
                    <td>
                      {room.name}
                      {(() => {
                        if (room.door_lock){
                          return(
                            <div className="text-muted small">
                              ({formatMessage(defaultMessages.clientHostPagesRoomsTableDoorLock)})
                            </div>
                          )
                        }
                      })()}
                    </td>
                    <td>{room.bed_type} / {room.bathroom_type}</td>
                    <td>
                      <RoomPhotoUpload
                        intl={this.props.intl}
                        photos={room.photos}
                        room={room}
                        onPhotoFormSubmit={this.props.onPhotoFormSubmit}
                        didInvalidate={this.props.rooms.didInvalidate}
                        onPhotoDestroySubmit={this.props.onPhotoDestroySubmit}
                        uploader={this.props.uploader}
                        user={this.props.user}
                        multiple={true}
                        disablePhotoTitle={this.props.territory.disable_host_photos_title_field} />
                    </td>
                    <td><a href="#" onClick={(e) => this.handleEditRoom(e, room)}><Edit/></a></td>
                  </TableRow>
                )
              })}
            </tbody>
          </table>

          {isFetching && rooms.length === 0 && <h5 className='text-center'>{formatMessage(defaultMessages.clientHostPagesRoomsStatesLoadingRooms)}</h5>}
          {!isFetching && rooms.length === 0 && <h5 className='text-center'>{formatMessage(defaultMessages.clientHostPagesRoomsStatesNoRooms)}</h5>}

          {
            this.props.territory.code == 'SRSC' &&
            !this.pageValid() &&
            <div className="alert alert-danger">
              <ReactMarkdown source={content.pages.rooms.invalid} />
            </div>
          }
          <ButtonGroup
            backFunc={this.back}
            skipFunc={this.props.territory.code != 'SRSC' ? this.skip : undefined}
            submitFunc={this.submit}
            page={thisPage}
            user={this.props.user}
            intl={this.props.intl}
            disableSubmit={!this.pageValid()} />
        </form>

        <Modal show={this.state.showModal} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>
              {
                activeRoom && activeRoom.id
                ? formatMessage(defaultMessages.clientHostPagesRoomsActionsUpdate)
                : formatMessage(defaultMessages.clientHostPagesRoomsActionsCreate)
              }
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>

          <RoomForm
            intl={this.props.intl}
            room={activeRoom}
            onRoomFormSubmit={this.props.onRoomFormSubmit}
            onClose={this.close}
            content={content}
            beddingOptions={this.props.beddingOptions}
            requiredFields={this.props.requiredFields} />

          </Modal.Body>
        </Modal>
      </div>
    )
  }
};

Rooms.propTypes = {
  onHostProfileSubmit: PropTypes.func,
  onRoomsRefresh: PropTypes.func,
  onRoomsSubmit: PropTypes.func,
  onSkipSubmit: PropTypes.func,
  onGoBack: PropTypes.func,
  page: PropTypes.string,
  intl: PropTypes.object,
  content: PropTypes.object,
  rooms: PropTypes.object
};

export default injectIntl(Rooms);
